import { render, staticRenderFns } from "./TheHamburger.vue?vue&type=template&id=63c0f00b&scoped=true"
import script from "./TheHamburger.vue?vue&type=script&lang=js"
export * from "./TheHamburger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c0f00b",
  null
  
)

export default component.exports